import { render, staticRenderFns } from "./DailyTraffic.vue?vue&type=template&id=63756ff4&scoped=true&"
import script from "./DailyTraffic.vue?vue&type=script&lang=js&"
export * from "./DailyTraffic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63756ff4",
  null
  
)

export default component.exports